import mergeClassNames from "common/mergeClassNames";

export type IDataPreviewDataType = Record<string, React.ReactNode>;

type IDataPreviewTableProps = {
    headers: IDataPreviewDataType;
    rows: IDataPreviewDataType[];
    children?: React.ReactNode;
    footer?: React.ReactNode;
    transposed?: boolean;
};

export default function DataPreviewTable({ children, headers, rows, footer, transposed = false }: IDataPreviewTableProps) {
    return (
        <table className={mergeClassNames("relative", transposed ? "flex min-w-fit flex-row flex-nowrap" : "w-full")}>
            <thead className={transposed ? "sticky left-0 inline-flex flex-row flex-nowrap self-start" : ""}>
                <tr className={transposed ? "inline-flex flex-col" : ""}>
                    {Object.keys(headers).map((col) => (
                        <th
                            key={`table-header-${col}`}
                            className={mergeClassNames(
                                "whitespace-nowrap border-b border-white bg-header-footer px-4 py-3 text-left align-top text-sm",
                                transposed ? "flex min-h-12 flex-row items-center justify-between gap-1" : "sticky top-0",
                            )}
                        >
                            {headers[col]}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody className={transposed ? "inline-flex flex-row flex-nowrap" : ""}>
                {rows.map((record, rowIndex) => (
                    <tr className={transposed ? "inline-flex flex-col" : "hover:bg-selected-row"} key={`table-body-row-${rowIndex}`}>
                        {Object.keys(headers).map((colIndex) => (
                            // Order by headers based on schema fields
                            <td
                                key={`${rowIndex}-${colIndex}`}
                                className={mergeClassNames(
                                    "whitespace-nowrap border-b border-slate-100 px-4 py-3 text-left align-top text-sm",
                                    transposed ? "block min-h-12 border-l hover:bg-slate-100" : "",
                                )}
                            >
                                {record[colIndex] || null}
                            </td>
                        ))}
                    </tr>
                ))}
                {children}
            </tbody>
            <tfoot>{footer}</tfoot>
        </table>
    );
}
